import { Box, EvaneosThemeProvider } from '@evaneos/b2b-ui';
import { createPortal } from 'react-dom';

import { HomeRoutes } from '../../routing/HomeRoutes';
import { setTheme, toastConfig } from '../../../styles/theme';

export const HomeLayout = (): JSX.Element => (
    <>
        {createPortal(<meta name="robots" content="noindex, nofollow" />, document.head)}
        <EvaneosThemeProvider rootHtmlFontSize={10} setTheme={setTheme} toastConfig={toastConfig}>
            <Box sx={{ height: '100%', overflowY: 'auto' }}>
                <HomeRoutes />
            </Box>
        </EvaneosThemeProvider>
    </>
);
